import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
/**
 * @entity ANPersonalakte
 *
 * This class is mostly a collection of file references
 * TODO uwe asks if this is still usefull
 */
@Entity()
export class ANPersonalakte extends AdornisEntity {
  static override _class = 'ANPersonalakte';

  @Field(type => ID)
  unterlagenID: Maybe<string>;

  @Field(type => ID)
  personalbogenID: Maybe<string>;

  @Field(type => [ID], { default: v => v ?? [] })
  vertraegeIDs: Maybe<string[]>;

  @Field(type => [ID], { default: v => v ?? [] })
  erklaerungenIDs: Maybe<string[]>;

  @Field(type => [ID], { default: v => v ?? [] })
  addIDs: Maybe<string[]>;
}
